'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.decorateWithDomParams = decorateWithDomParams;
var isWindowAvailable = exports.isWindowAvailable = typeof window !== 'undefined';

function decorateWithDomParams(fn) {
  return function (params) {
    var screenWidth = !isWindowAvailable ? 980 : window.screen.width; // TODO: maybe  Math.min(window.screen.width, window.document.body.offsetWidth)
    var screenPixelRatio = !isWindowAvailable ? 1 : window.devicePixelRatio;
    return fn(_extends({}, params, { sW: screenWidth, pR: screenPixelRatio }));
  };
}